<template>
    <Toast />
    <div
        class="flex justify-content-center aling-items-center"
        :class="{
            'banner-vw': brand === 'vw',
            'banner-audi': brand === 'audi',
            'banner-seat': brand === 'seat',
            'banner-porsche': brand === 'porsche',
        }"
    ></div>
    <div class="px-6 py-2 mt-6 md:px-6 flex flex-column lg:px-7">
        <div class="flex align-items-center justify-content-center">
            <div v-if="couponStore.campaingValid === 'Activa'" class="w-81rem m-2 md:m-4 lg:my-1">
                <h1 class="font-bold text-4xl text-primary">Bienvenido a Digital Voucher</h1>
                <span class="font-bold block text-lg mt-2 text-primary">
                    Gracias por tu interés
                </span>

                <FORM :validation-schema="schema" @submit="onSubmit">
                    <div class="grid mt-6">
                        <div class="col-10 md:col-6 lg:col-4">
                            <Field v-slot="{ field, errorMessage }" name="email">
                                <div class="field mb-5">
                                    <InputText
                                        v-bind="field"
                                        :disabled="checked"
                                        aria-describedby="email-help"
                                        class="w-full sm:w-5 md:w-8 lg:w-8 xl:w-8"
                                        placeholder="Email"
                                        :class="{ 'p-invalid': errorMessage }"
                                    />
                                    <small id="email-help" class="p-error block">{{
                                        errorMessage
                                    }}</small>
                                </div>
                            </Field>
                            <PrimeButton
                                type="submit"
                                :loading="loading"
                                class="rounded w-full sm:w-5 md:w-6 lg:w-8 xl:w-5 mt-6 block mt-6 block"
                                label="Validar"
                            />
                        </div>
                    </div>
                </FORM>
            </div>
            <div v-else class="w-81rem m-2 md:m-4 lg:my-1">
                <h1 class="font-bold text-4xl text-primary">
                    {{ couponStore.menssage }}
                </h1>
                <span class="font-bold block text-lg mt-2 text-primary">
                    Gracias por tu interés
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { onBeforeMount, defineComponent, ref } from "vue";
import { Form as FORM, Field } from "vee-validate";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import { useCouponStore } from "../stores/cupones/couponStore";
import { useRoute } from "vue-router";
import { notify } from "@kyvg/vue3-notification";

import * as yup from "yup";
export default defineComponent({
    name: "Home",
    components: {
        FORM,
        Field,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const couponStore = useCouponStore();
        const toast = useToast();
        const loading = ref(false);
        const checked = ref(false);
        const brand = localStorage.getItem("brand") as string;
        /**
         * Método agregar un loader al botón y desactivar el input mientras se valida la información del usuario
         * @return {void} Sin respuesta
         */
        const load = (): void => {
            loading.value = true;
            checked.value = true;
            setTimeout(() => {
                checked.value = false;
                loading.value = false;
            }, 3000);
        };

        onBeforeMount(async () => {
            load();
            couponStore.loading = true;
            const campaing_id = route.params.idCampaing?.toString() || "";
            await couponStore.validateCampaingbyId(campaing_id);
        });

        /**
         * Método para enviar la información del input (correo) y pueda ser validado por el backend
         * @return {Promise<void>} Sin respuesta
         */
        async function onSubmit(values: any): Promise<void> {
            try {
                load();
                const campaing_id = route.params.idCampaing?.toString() || "";
                if (campaing_id !== "") {
                    couponStore.setCampaing(campaing_id);
                    couponStore.setEmail(values.email);
                    const validateCoupon = await couponStore.validateCoupon(
                        values.email,
                        campaing_id
                    );
                    if (!validateCoupon.data.hasBonus) {
                        router.push({ path: "/datos" });
                    } else {
                        if (validateCoupon.data.bonus.redeemed === true) {
                            couponStore.setCodeCoupon(validateCoupon.data.bonus.code);
                            couponStore.setCampaingName(validateCoupon.data.bonus.campaign_name);
                            router.push({ path: "/cupon", query: { status: 3 } });
                        } else {
                            couponStore.setCodeCoupon(validateCoupon.data.bonus.code);
                            couponStore.setCampaingName(validateCoupon.data.bonus.campaign_name);
                            router.push({ path: "/cupon", query: { status: 2 } });
                        }
                    }
                } else {
                    toast.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: "No se cuenta con una campaña válida",
                        life: 3000,
                    });
                }
            } catch (e: any) {
                notify({
                    title: "Hubo un error",
                    type: "error",
                    text: e.errorMessage,
                });
            }
        }
        /**
         * variable que contiene las validaciones del formulario
         */
        const schema = yup.object({
            email: yup
                .string()
                .required("El correo es un campo necesario")
                .email("Debe ser un formato válido"),
        });

        return {
            onSubmit,
            brand,
            schema,
            loading,
            checked,
            couponStore,
        };
    },
});
</script>

<style></style>
